import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../styles/portfolio.css';
import Projects from '../components/projects';

class PortfolioPage extends Component {
  constructor(props) {
    super(props);
    this.enableScroll = this.enableScroll.bind(this);
  }

  enableScroll() {
    if (window.removeEventListener) {
      window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
    }
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
  }

  componentWillMount() {
    this.enableScroll();
  }

  componentDidMount() {
    window.addEventListener('resize', this.enableScroll, false);
  }

  renderGallery() {
    const gallery = Projects.map(project => {
      return (
        <Link key={project.title} to={project.route}>
          <div
            className="projectThumbnail"
            style={{ backgroundImage: `url(${project.thumb})` }}
          >
            <div className="titleOverlay">
              <h2>{project.title}</h2>
            </div>
          </div>
        </Link>
      );
    });
    return gallery;
  }

  render() {
    return (
      <div className="portfolioContainer">
        <div className="galleryContent">{this.renderGallery()}</div>
      </div>
    );
  }
}

export default PortfolioPage;



// WEBPACK FOOTER //
// ./src/containers/portfolio.js